<template>
  <div>
    <base-form
      v-if="relationResource && newRecord && newRecord.id"
      :resource="relationResource"
      :is-modal="true"
      :id="newRecord.id"
      :compare="!liveRecordEmpty && !newRecordEmpty"
      :pending-approval="liveRecordEmpty"
      :compare-id="petaLiveRecord && petaLiveRecord.id ? petaLiveRecord.id : 0"
    ></base-form>
    <q-inner-loading :visible="loading"></q-inner-loading>
  </div>
</template>

<script>
export default {
  name: 'CompareForm',
  props: {
    relationResource: {
      type: String,
      default: () => null
    },
    newRecord: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      ready: false,
      liveRecord: {},
      petaNewRecord: {},
      petaLiveRecord: {}
      // compare: true
    }
  },
  computed: {
    newRecordEmpty () {
      return Object.entries(this.newRecord).length === 0 && this.newRecord.constructor === Object
    },
    liveRecordEmpty () {
      return Object.entries(this.petaLiveRecord).length === 0 && this.petaLiveRecord.constructor === Object
    }
  },
  methods: {
    async findNewRecord () {
      try {
        const {data} = await this.$axios.get(`/api/${this.relationResource}/${this.newRecord.id}`)
        if (data) {
          this.petaNewRecord = data
        } else {
          this.$q.notify({
            message: 'Error fetching record'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching record'
        })
      }
    },
    async findLiveRecord () {
      if (this.petaNewRecord && this.petaNewRecord.guidId) {
        try {
          const {data} = await this.$axios.get(`/api/${this.relationResource}/list?sql=where guid_id="${this.petaNewRecord.guidId}" and approved=1`)
          // console.log(data)
          if (data && data[0]) {
            this.petaLiveRecord = data[0]
          } else {
            // this.compare = false
            // this.$q.notify({
            //   message: 'Error fetching record'
            // })
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error fetching record'
          })
        }
      } else {
        this.$q.notify({
          message: 'New record not found'
        })
      }
    }
  },
  created: async function () {
    if (this.newRecord && this.relationResource) {
      await this.findNewRecord()
      await this.findLiveRecord()
    }
    this.loading = false
    this.ready = true
  }
}
</script>

<style scoped>

</style>
